import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanLoad, Route } from '@angular/router';
import { Observable } from 'rxjs';
import { StorageService } from '../../services/storage.service';

@Injectable({
  providedIn: 'root'
})

export class AuthGuardService implements CanActivate, CanLoad {

  constructor(
    protected storage: StorageService,
    protected route: Router) { }

  protected isAuthetication() {


   // console.log("passou pela AuthGuardService")
    if (this.storage.getLocalUser()) {
      return true;
    } else {
      this.route.navigate(['/login']);
      return false;
    }
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
   // console.log(state.url)
    return this.isAuthetication();
  }

  canLoad(route: Route): boolean | Observable<boolean> | Promise<boolean> {
    return this.isAuthetication();
  }

}
